<template>
  <div class="row">
    <div class="col-md-12">
      <p class="align-middle border p-2 bg rounded-1">
        {{ this.$route.params.action }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuccessMessage",
};
</script>
<style scoped>
.bg {
  color: #3a87ad;
  background-color: #d9edf7;
  border-color: #bce8f1;
}
</style>